import * as React from "react";
export const LegalFooter = ({ children }) => (React.createElement("div", { className: "flex flex-row gap-4 text-xs" },
    children,
    React.createElement("a", { href: "https://www.skve.de/impressum", target: "_blank", rel: "noopener noreferrer" }, "Impressum")));
//# sourceMappingURL=LegalFooter.js.map